import React from 'react';

const TYPE_STYLES = {
    info: 'bg-blue-50 border-blue-500 text-blue-800 dark:bg-blue-950/50 dark:text-blue-200',
    success: 'bg-emerald-50 border-emerald-500 text-emerald-800 dark:bg-emerald-950/50 dark:text-emerald-200',
    warning: 'bg-amber-50 border-amber-500 text-amber-800 dark:bg-amber-950/50 dark:text-amber-200',
    error: 'bg-red-50 border-red-500 text-red-800 dark:bg-red-950/50 dark:text-red-200',
};

export function Alert({ type = 'info', children, onClose }) {
    const styles = TYPE_STYLES[type] || TYPE_STYLES.info;

    return (
        <div className={`flex items-start gap-2 px-4 py-3 mb-3 rounded-lg border-l-4 text-sm ${styles}`}>
            <div className="flex-1">{children}</div>
            {onClose && (
                <button
                    className="flex-shrink-0 ml-2 text-current opacity-60 hover:opacity-100 text-lg leading-none transition-opacity"
                    onClick={onClose}
                    aria-label="Close alert"
                >
                    &times;
                </button>
            )}
        </div>
    );
}
